<template>

    <div class="outer-wrapper">

        <div class="inner-wrapper" v-if=" currentCard ">

            <div class="qr-wrapper">

                <canvas id="canvas"></canvas>
            </div>
            <div class="details-wrapper">

                <p class="merchant-name">{{ currentCard.Merchant.name }}</p>
                <p class="card-value">${{ currentCard.PrepaidAccount.balance }}</p>
                <p class="card-expiration">{{ expiration }}</p>
                <p class="card-token">{{ paytoken }}</p>
            </div>
        </div>
        <div v-else class="nothing-loaded-wrapper">

            No Card Loaded
        </div>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import QRCode from 'qrcode';

    export default {

        name: 'view-card',
        computed: {

            ...mapGetters({

                currentCard       : 'cards/currentCard',
                merchantLocations : 'merchant/allLocations'
            }),
            expiration(){

                return this.currentCard.PrepaidAccount.expiration || 'never expires';
            },
            paytoken(){

                let token = '';
                for( var i = 0; i < 16; i += 4 ){

                    token += this.currentCard.Paytoken.token.substr( i, 4 ) + ' ';
                }

                return token;
            }
        },
        mounted(){


            // With promises
            QRCode.toDataURL( document.getElementById( 'canvas' ), this.currentCard.Paytoken.token )
            .then( url => {

                // console.log( url )
            })
            .catch( err => {

                console.error( err )
            })
        }
    }
</script>

<style scoped>

    .outer-wrapper {

        padding-top: 0 !important;
    }
    .qr-wrapper {

        background-color: white;
        padding: 75px 0px;
        text-align: center;
    }
    .details-wrapper > p {

        font-weight: bold;
        text-align: center;
    }
    .merchant-name {

        font-size: 26px;
        padding: 20px 0;
    }
    .card-value {

        font-size: 24px;
    }
    .card-token {

        padding-top: 40px;
        font-size: 20px;
    }
</style>